import React, { FC } from 'react'

import { IconCaseStudyProps } from './IconCaseStudy.types'
import * as Styled from './styles/IconCaseStudy.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCaseStudy: FC<IconCaseStudyProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCaseStudyProps['size'],
  isResponsive = false,
}: IconCaseStudyProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M32.75 17H21' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M32.75 23H21m11.75 6H21m11.75 6H21' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M39 9v30a4 4 0 0 1-4 4H19a4 4 0 0 1-4-4V13a4 4 0 0 1 4-4h20Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M33 9V5H13a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4h2' stroke='#0D0D0D' strokeMiterlimit='10' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCaseStudy
